class QuickCart extends HTMLElement {
  constructor() {
    super();

    this.open = false;
    this.options = this.querySelectorAll(".size-selector label");
    this.wrapper = this.querySelector(".card__action");
    this.productUrl = this.dataset.productUrl;
    this.form = this.querySelector("form");
    this.productForm = this.form.closest("product-form");
    this.sizeSelector = this.querySelector(".size-selector");
    this.init();
  }

  init() {
    this.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (this.sizeSelector) this.toggle();
      else this.productForm.onSubmitHandler();
    });

    this.wrapper.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
    });

    this.options.forEach((option) => {
      option.addEventListener("click", async () => {
        const inputId = option.getAttribute("for");

        const input = document.querySelector(`.size-selector #${inputId}`);
        if (!input) return;

        const sizeValue = input.value;

        // Find or create the hidden input
        let sizeOption = this.form.querySelector('input[name="size-option"]');
        if (!sizeOption) {
          sizeOption = document.createElement("input");
          sizeOption.type = "hidden";
          sizeOption.name = "size-option";
          this.form.appendChild(sizeOption);
        }

        sizeOption.value = sizeValue;
        const colorValue = this.form.querySelector(`[name='color-option']`)?.value;
        const params = [colorValue, sizeValue].filter((item) => item).join(",");

        const res = await fetch(`${this.productUrl}?section_id=quick-cart-id&options=${params}`);
        const responseText = await res.text();
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const variantId = html.getElementById("variant_id").textContent;

        const variantInput = this.form.querySelector('[name="id"]');
        variantInput.value = variantId.trim();

        this.productForm.onSubmitHandler();
      });
    });
  }

  toggle(isOpen = !this.open) {
    if (!isOpen) this.removeAttribute("open");
    else {
      document.querySelectorAll("quick-cart").forEach((item) => item.toggle(false));
      this.setAttribute("open", "");
    }

    this.open = isOpen;
  }
}

customElements.define("quick-cart", QuickCart);
